export const BLANK_MAP = {
  origin: 'http://t7.local',
  blankMap: {
    unit: 'mmHg',
    rows: 16,
    values: new Array(256).join('0').split(''),
    columns: 16,
  },
  cellMax: 200,
  cellsPerRegion: 4,
  rows: 16,
  regionRows: 2,
  regions: 64,
  values: new Array(256),
  unit: 'mmHg',
  columns: 16,
  regionCols: 2,
};

export const DATA_DIRS = {
  mat_data_directory: 'mat_data',
  shift_data_directory: 'shift_data',
  shift_maps_directory: 'shift_maps',
  alert_data_directory: 'alert_data',
  reminder_data_directory: 'reminder_data',
  week_data_directory:  'weekly_shifts',
  test_data_directory:  'test',
};

export const SERVERS = {
  utmb: 'https://awshift.utmb.edu/',
  mayo: 'https://api.aw-shift.com',
  test: 'https://awshift-test-server.azurewebsites.net/',
  va: 'https://prd-made-awshift-backend.apps.vapo-az-arches.va.gov',
  local: 'http://localhost:8080',
  umn: 'https://api.awshift-va.ahc.umn.edu',
};

export const NOTIFICATION_IDS = {
  dailyNotification: 8,
};


export const DEFAULT_SETTINGS = {
  shiftInterval: 60 * 60 * 2, //seconds * minutes * hours
  shiftDailyGoalCount: 10,
  shiftDuration: 120,
  shiftDailyGoalProgress: 0,
  dafaultStartTimeHour: 8,
  dafaultStopTimeHour: 20,
  dafaultStartTimeMinute: 0,
  dafaultStopTimeMinute: 0,
  globalAlertTriggerPct: 50,
  globalAlertTriggerThreshold: 70,
  localAlertTriggerPpi: 150,
  localAlertTimeThreshold: 40,
  uploadContinuosMaps: true,
  uploadIntervalMinutes: 5,
  uploadContinuosMetrics: false,
  showNotifications: false,
  dailyNotifications: false,
  soundNotifications: false,
  soundOnComplete: false,
  soundOnNotification: false,
  showProgress: false,
  showDetails: false,
  showPPIDetails: false,
  sampleRate: 10,
  showShiftTimer: false,
  inputRotation: 'Front',
  selectedTheme: 'light',
  selectedMapColor: 'default',
  shiftsPerHour: 4,
  detectShifts: true,
  editBy: 'patient',
  pressureReliefTechnique: 'manual',
  detectionDuration: 5,
  detectionPPIThreshold: 75,
  detectionPPICount: 5,
  performCalibration: false,
  isHeadless: false,
  isPowerSeating: false,
};


export const DEFAULT_SHOW_SETTINGS = {
  isHeadless: false,
  weightShift: true,
  time: true,
  color: true,
  notification: true,
  dataCollection: true,
  mapSettings: true,
  globalPressure: true,
  localPressure: true,
  recordingsTab: true,
  graphsTab: true,
  pressureReliefTechnique: true,
};
